<template>

  <Form :model="order" :label-width="120" label-position="right" ref="aicOrderForm" :rules="rules">
    <div v-show="order.orderType==='1'" class="p-16">

<!--      <div class="f-18 m-b-18">-->
<!--        本次办理信息平台共享-->
<!--      </div>-->
<!--      <div class="f-16 m-b-16 f-w-700">温馨提示：</div>-->
<!--      <div class="f-16 m-b-32">如果您的新开办企业符合当地政府免费刻章优惠政策，免费给您提供首套公章。详情请咨询当地各服务大厅或刻章企业。</div>-->

      <div class="c-gray f-16 m-b-16">
        单位信息
      </div>
      <FormItem label="信用代码：">{{ order.uscc }}</FormItem>
      <FormItem label="单位名称：">{{ order.name }}</FormItem>
<!--      <div class="c-gray f-16 m-b-16">-->
<!--        法定代表人-->
<!--      </div>-->
<!--      <FormItem label="姓名：">{{ order.crpName }}</FormItem>-->
<!--      <FormItem label="证件类型："><span v-dict:DictGb_personCertType="order.crpCertType"></span></FormItem>-->
<!--      <FormItem label="证件号码：">{{ order.crpCertNo }}</FormItem>-->
<!--      <FormItem label="预留手机：">{{ order.crpPhone }}</FormItem>-->

      <div class="c-gray f-16 m-b-16">
        经办人
      </div>
      <FormItem label="姓名：">{{ order.opName }}</FormItem>
      <FormItem label="证件类型："><span v-dict:DictGb_personCertType="order.opCertType"></span></FormItem>
      <FormItem label="证件号码：">{{ order.opCertNo }}</FormItem>
      <FormItem label="预留手机：">{{ order.opPhone }}</FormItem>
    </div>
  </Form>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'OrderCompanySamr',
  data() {
    return {
      rules: {},
    }
  },
  props: {},
  computed: {
    ...mapState({
      order: state => state.order.currentOrder,
    }),
  },
  methods: {},
  created() {
  }
}
</script>
